import React, { Component } from 'react';
import { animateScroll } from 'react-scroll';

import AnchorLink from 'react-anchor-link-smooth-scroll'
import './Scrollbar.css'


class Scrollbar extends Component {

    state = {
        offset: this.props.offset || 1000,
        show: false
    }

    componentDidMount = () => {

        window.addEventListener("scroll", () => {
            if (window.pageYOffset > this.state.offset) {
                this.setState({
                    ...this.state,
                    show: true
                })
            } else {
                this.setState({
                    ...this.state,
                    show: false
                })
            }
        })
    }

    scrollToTop = () => {
        animateScroll.scrollToTop();
        console.log("scrol")
    }
    render() {
        return (
            <>
                {this.state.show && (
                    <div className="col-lg-12">
                        <div className="header-menu">

                            <button className="smothscroll"
                                onClick={this.scrollToTop}
                                style={{ display: "block" }}>
                                <li><AnchorLink onClick={this.scrollToTop} href='/'><i className="ti-arrow-up"></i></AnchorLink></li>
                            </button>
                        </div>
                    </div>
                )}

            </>
        );
    }
}

export default Scrollbar;